import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import "./app/i18n";
import App from "./app/App";
import { Providers } from "./app/providers/app-providers";
import reportWebVitals from "./reportWebVitals";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(Providers, { children: _jsx(App, {}) }));
reportWebVitals();
